import { ToggleType } from 'types/Financials';

export const findConfigFlagByCode = (configFlagCode: string, configFlags: ToggleType[] | null): ToggleType | null => {
  const item = configFlags && configFlags.find((entry) => entry && entry.code === configFlagCode);
  return item ? item : null;
};

export const NNM_ENABLED_FLAG = 'NNM';
export const INVESTMENT_PROFILE_ENABLED_FLAG = 'CIP';
